import React from 'react';
import Profile from '../component/comman/Profile';
import Sidebar from '../component/comman/Sidebar';
import MobileMenu from '../component/comman/MobileMenu';

const Layout = ({ children }) => {
  return (
    <>
      <Sidebar/>
      <div className="home-section">
        <Profile/>
        {children}
        <MobileMenu/>
      </div>
    </>
  );
};

export default Layout;